export const eeaCountries = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'GB',
  'CH',
  'AE',
];

export const essentialCookies = [
  'session_id_nuts',
  'session_id_bolts',
  'NEXT_LOCALE',
  '__cf_bm',
  'g_state',
  // google.com
  'APISID',
  'SAPISID',
  'HSID',
  'SSID',
  'SID',
  'SIDCC',
  '__Secure-1PSID',
  '__Secure-1PSIDCC',
  '__Secure-1PSIDTS',
  '__Secure-3PAPISID',
  '__Secure-3PSID',
  '__Secure-3PSIDCC',
  '__Secure-3PSIDTS',
  '__Secure-STRP',
  // accounts.google.com
  '__Host-1PLSID',
  '__Host-3PLSID',
  '__Host-GAPS',
  'ACCOUNT_CHOOSER',
  'LSID',
];
